export const DAY_IN_SECONDS = 24 * 60 * 60



// WEBPACK FOOTER //
// ./src/constant.js